// orchestrator_fullstack/frontend/src/app/auth/RequireAuth.tsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthProvider";

/**
 * Route guard:
 * - Authenticated means: token exists AND backend returned a user
 * - Redirects to /login?next=... if not authenticated
 * - Avoids flicker while auth is being refreshed by using fetchedAt as a best-effort "loaded" signal
 */
export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { state } = useAuth();
  const loc = useLocation();

  const token = state.token;
  const isAuthed = Boolean(token && state.user);

  // Best-effort loading detection:
  // - If no token => definitely not authed, redirect
  // - If token exists but we haven't fetched auth/me yet (fetchedAt null),
  //   render nothing briefly while AuthProvider refresh() runs on mount.
  const isLoading = Boolean(token && !state.fetchedAt && !state.user);

  if (isLoading) return null;

  if (!isAuthed) {
    const next = encodeURIComponent(loc.pathname + loc.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  return <>{children}</>;
}

export default RequireAuth;